import { render, staticRenderFns } from "./EscolherAcesso.vue?vue&type=template&id=2b706756&scoped=true"
import script from "./EscolherAcesso.vue?vue&type=script&lang=js"
export * from "./EscolherAcesso.vue?vue&type=script&lang=js"
import style0 from "./EscolherAcesso.vue?vue&type=style&index=0&id=2b706756&prod&lang=scss&scoped=true"
import style1 from "./EscolherAcesso.vue?vue&type=style&index=1&id=2b706756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b706756",
  null
  
)

export default component.exports